import React, {useState, useRef} from 'react'
import {useProducts} from '@salesforce/commerce-sdk-react'
import {Grid, GridItem, useMultiStyleConfig, GridProps} from '@chakra-ui/react'
import {ProductTile, ProductSkeleton} from '_uiComponents'
import {toEditorialAnalyticsList} from '_analytics/utils/analyticsUtils'

interface ShopTheImageProps {
    productsIds: string
    analyticsList?: string
}

const ShopTheImage = ({productsIds, analyticsList}: ShopTheImageProps) => {
    const styles = useMultiStyleConfig('ShopTheImage') as Record<string, GridProps>
    const [nextImpressionIndex, setNextImpressionIndex] = useState(0)
    const viewedTiles = useRef(new Set<number>())
    const analyticsListBase = toEditorialAnalyticsList(analyticsList)
    const analyticsListRelatives = analyticsListBase ? `${analyticsListBase}-shop-the-image` : ''
    const productIdsList = productsIds.replaceAll('\n', ',')

    const {data: products, isLoading} = useProducts(
        {
            parameters: {
                ids: productIdsList,
            },
        },
        {
            keepPreviousData: true,
            staleTime: Infinity,
            cacheTime: Infinity,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        },
    )

    return (
        <Grid {...styles.productsGrid}>
            {isLoading
                ? Array.from({length: 6}, (_, index) => (
                      <GridItem key={`skeleton-${index}`}>
                          <ProductSkeleton />
                      </GridItem>
                  ))
                : products?.data.map((product, idx) => {
                      const productId = product.productId || product.id
                      const normalizedProduct = product.productId ? product : {...product, productId}
                      return (
                          <GridItem key={productId ?? `shop-image-${idx}`}>
                              <ProductTile
                                  product={normalizedProduct}
                                  idx={idx}
                                  nextImpressionIndex={nextImpressionIndex}
                                  setNextImpressionIndex={setNextImpressionIndex}
                                  viewedTiles={viewedTiles}
                                  shouldHideWishlistButton={true}
                                  showCarousel={false}
                                  showCover={false}
                                  analyticsList={analyticsListRelatives}
                                  listingLayout={'shoptheimage'}
                                  variant={'shoptheimage'}
                              />
                          </GridItem>
                      )
                  })}
        </Grid>
    )
}

export {ShopTheImage}
